import { Injectable, Component, Inject, OnInit } from '@angular/core';
import {DwModalService} from 'ng-quicksilver';
import {LoginComponent} from './login/login.component';

@Injectable({
  providedIn: 'root'
})
export class FxLoingingService  {
 
  constructor( public dwModalService: DwModalService) {
  }

  openLoginModal(fxMedia?: any): void{
    this.dwModalService.create({
      dwTitle: null,
      dwStyle: fxMedia == 'mobile' ? { margin: '0 5%', top: '150px' } : { top: '100px' },
      // dwBodyStyle: {background: '#ccc'},
      dwWrapClassName: (fxMedia && fxMedia === 'mobile') ? 'fx-login-wrap fx_lg_modal' : 'fx-login-wrap',
      dwMaskClosable: false, // 點擊遮罩是否允許關閉
      dwContent: LoginComponent,
      dwWidth: (fxMedia && fxMedia === 'mobile') ? window.screen.width * 0.4 : window.screen.width * 0.5,
      dwFooter: null,
      dwComponentParams: {         
        modalScope: this
      },
    });
  }

}
